
import _ from 'lodash'
import { mapGetters } from 'vuex'

import card from '~/mixins/card'
import { selfEnrollItems } from '~/util/aep-recommendation'
export default {
    mixins: [card],
    props: {
        magicUrl: {
            type: String,
            default: '/'
        },
    },
    computed: {
        ...mapGetters([
            'uid',
            'surveyRoutesMap',
            'isPlanInOpportunities',
        ]),
        // todo: needs to split ma and mapd
        mapdPlan () {
            return _.find(this.summaryCombosPlans, p => p.mapd_or_ma)
        },
        suppPlan () {
            return _.find(this.summaryCombosPlans, p => p.supp)
        },
        pdpPlan () {
            return _.find(this.summaryCombosPlans, p => p.pdp)
        },
        // a computed, not `?.` in the template: vue-jest's buble cannot parse it
        switchPlanName () {
            return (this.mapdPlan && this.mapdPlan.name) || (this.pdpPlan && this.pdpPlan.name)
        },
        // The plans Plans Actions Enroll shows a button for (same rule).
        agentEnrollPlans () {
            return (this.summaryCombosPlans || []).filter(p => this.isPlanIncluded(p) && this.canAgentEnrollPlan(p))
        },
        // Every other option plan, excluded or not, as AEP's selfRxPlans.
        selfEnroll () {
            const plans = (this.summaryCombosPlans || []).filter(p => !this.canAgentEnrollPlan(p))
            return selfEnrollItems({ payer: !!this.fullservePlus, year: this.year }, plans.map(p => this.$store.getters.toEnginePlan(p)))
        },
        selfEnrollSteps () {
            return this.selfEnroll.filter(s => s.steps)
        },
    },
}
